<template>
  <div id="cartitem">
    <section class="item_field">
      <div class="caution_field" v-if="cartData.isDisProduct===true">
        <div class="caution_inner">
          <ul class="caution_text">
            <li>この商品は商品仕様が変更、または取り扱いが終了した為、購入できません。</li>
            <li>カートから削除してください。</li>
          </ul>
        </div>
      </div>
      <div class="flex-just-space">
        <div class="image" v-bind:class="{'disabled':cartData.isDisProduct===true}">
          <img :src="itemImage" alt="" width="200px">
        </div>
        <div class="info">
          <ul>
            <li>
              <span v-bind:class="{'cart-item-title':true, 'disabled':cartData.isDisProduct===true}">
                <div v-if="odMgId">{{odMgId}}</div>
                <div v-if="corpData">{{corpData.corpName}}</div>
                <div>{{cartData.infoSeriesName}}</div>
                <div id="item_name">{{cartData.infoProductName}}</div>
              </span>
              <span class="cart_btn_list left" v-if="type==='history'">
                <button v-bind:class="{'main_btn':true, 'cart_btn':true, 'disabled':cartData.isDisProduct===true}" @click="onEstimate(cartData)" v-if="cartData.infoCategoryType == 5 || isBeforeDate">図面</button>
                <button v-bind:class="{'main_btn':true, 'cart_btn':true, 'disabled':cartData.isDisProduct===true}" @click="onEstimate(cartData)" v-else>図面/見積り</button>
              </span>
              <span class="cart_btn_list left" v-else-if="type==='cart'">
                <button v-bind:class="{'main_btn':true, 'cart_btn':true, 'disabled':cartData.isDisProduct===true}" @click="onEstimate(cartData)">図面/見積り</button>
                <button v-bind:class="{'main_btn':true, 'cart_btn':true, 'disabled':cartData.isDisProduct===true}" @click="onAfterCart(cartData)">後で買うリストに追加</button>
                <button v-bind:class="{'main_btn':true, 'cart_btn':true, 'disabled':cartData.isDisProduct===true}" @click="onCG(cartData)" v-if="isOutputCG && !isMiuraCompany">CG出力</button>
                <button class="main_btn delete_btn2 cart_btn" @click="onDelete(cartData)">削除</button>
              </span>
              <span class="cart_btn_list left" v-else-if="type==='after'">
                <button class="main_btn cart_btn" @click="onReverseCart(cartData)" v-if="type==='after'">カートに戻す</button>
                <button class="main_btn delete_btn2 cart_btn" @click="onDelete(cartData)">削除</button>
              </span>
            </li>
            <li v-bind:class="{'some':true, 'disabled':cartData.isDisProduct===true}">
              <span>商品サイズ</span>
              <span>
                <div>W:{{cartData.infoW}}mm</div>
                <div v-show="cartData.infoFillerLeft!=undefined">{{labelLeftFiller}}:{{cartData.infoFillerLeft}}mm</div>
              </span>
              <span>
                <div>H:{{cartData.infoH}}mm</div>
                <div v-show="cartData.infoFillerRight!=undefined">{{labelRightFiller}}:{{cartData.infoFillerRight}}mm</div>
              </span>
              <span>
                <div>D:{{cartData.infoD}}mm</div>
                <div v-show="cartData.infoFillerCenter!=undefined">{{labelCenterFiller}}:{{cartData.infoFillerCenter}}mm</div>
              </span>
            </li>
            <li v-bind:class="{'some':true, 'disabled':cartData.isDisProduct===true}" v-if="isExistStyle">
              <span>スタイル名</span>
              <span>{{cartData.colorStyle.colorStyleName}}</span>
            </li>
            <li v-bind:class="{'disabled':cartData.isDisProduct===true}">
              <ul id="color_list">
                <li v-if="isDoor">
                  <dd-color
                    :title="'扉カラー'"
                    :color="colorDoor"
                  />
                </li>
                <li v-if="isCabine">
                  <dd-color
                    :title="'キャビネット/棚/脚カラー'"
                    :color="colorCabine"
                  />
                </li>
                <li v-if="isCounter">
                  <dd-color
                    :title="'カウンターカラー'"
                    :color="colorCounter"
                  />
                </li>
              </ul>
            </li>
          </ul>
          <ul id="ul2_list" v-bind:class="{'disabled':cartData.isDisProduct===true}">
            <li class="some2">
              <span>{{optShelfTitle}}</span>
              <span>{{cartData.infoShelfCount}}{{optShelfUnitTitle}}</span>
              <span>
                <span>お届け先 〒{{cartData.infoDeliPostcd}}</span>
              </span>
            </li>
            <li class="some2" v-if="cartData.infoCategoryType !== 5">
              <span>追加フィラー</span>
              <span>{{cartData.infoFillerCount}}本</span>
              <span v-if="type==='history'">
                <span>ご注文数 {{cartData.infoProductCount}}</span>
              </span>
              <span v-else>
                <span>
                  ご注文数
                  <input type="text" class="order_cart_cnt" v-model="cartData.infoProductCount" @input="cartData.infoProductCount=inputRestNumber($event)" maxlength="2"/>
                </span>
                <div v-bind:class="{main_btn: true}" @click="onUpdate(cartData)">
                  <a class="white">
                    <i class='bx bx-revision'></i>
                    <label>更新</label>
                  </a>
                </div>
              </span>
            </li>
            <li class="some2" v-if="cartData.infoCategoryType !== 5">
              <span>組立設置</span>
              <span>{{isConstruct}}</span>
              <span>
                <span>小計 {{formatPrice(profitPrice(priceData.totalPrice))}}</span>
              </span>
            </li>
            <li class="some2" v-else>
              <span></span>
              <span></span>
              <span>
                <span>小計 {{formatPrice(profitPrice(priceData.totalPrice))}}</span>
              </span>
            </li>
            <template v-if="cartData.opExFlag">
              <li class="some2" v-if="isOutputCG && cartData.opExFlag">
                <span>組立設置先郵便番号</span>
                <span v-if="cartData.infoStructPostcd">〒{{cartData.infoStructPostcd}}</span>
                <span v-else></span>
              </li>
              <li class="some2" v-if="isOutputCG && isCarryIn != undefined">
                <span>受け取り搬入サービス</span>
                <span>{{isCarryIn}}</span>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
// import axios from 'axios'
// import {mapActions, mapState} from 'vuex'
// import draggable from 'vuedraggable'

// Module
// import * as Api from '../../utils/Api'
import * as App from '../../../utils/App'
// import * as FormUtil from '../../../utils/FormUtil'
import Color from '../top/input/color/DcColorForCart'
import * as FormUtil from '../../../utils/FormUtil'

export default {
  name: 'CartItem',
  components: {
    // draggable,
    'dd-color': Color
  },
  props: {
    cartData: Object,
    type: String,
    isOutputCG: Boolean,
    profitProb: {
      type: Number,
      default: 1
    },
    isBeforeDate: {
      type: Boolean,
      default: false
    },
    odMgId: String
  },
  data () {
    return {
      titleNoData: {}
    }
  },
  computed: {
    priceData: function () {
      let priceData = {
        itemName: this.cartData.infoProductName,
        itemModelList: this.cartData.itemDataList,
        itemPrice: this.cartData.itemPrice,
        constructPrice: this.cartData.constructPrice,
        subTotalPrice: this.cartData.subTotalPrice,
        delivaryPrice: this.cartData.deliveryPrice,
        totalPrice: this.cartData.price,
        executionVarExpensesPrice: this.cartData.executionVarExpenses,
        carryInPrice: this.cartData.carryInPrice,
        optionSubTotalPrice: this.cartData.optionSubTotalPrice,
        productCount: this.cartData.infoProductCount,
        profitProb: this.profitProb
      }
      return priceData
    },
    itemImage: function () {
      if (!this.cartData || !this.cartData.itemImage) return this.getImage('noimage.svg')
      return this.getImage('top/series/' + this.bigImage(this.cartData.itemImage))
    },
    colorDoor: function () {
      if (!this.cartData || !this.cartData.doorColor || Object.keys(this.cartData.doorColor).length <= 0) return undefined
      let data = this.cartData.doorColor
      let color = {
        id: data.no,
        name: data.name,
        type: data.type,
        no: data.dispNo,
        img: this.getImage('color/' + data.img),
        imgB: this.getImage('color/' + this.bigImage(data.img))
      }
      return color
    },
    colorCabine: function () {
      if (!this.cartData || !this.cartData.boxColor || Object.keys(this.cartData.boxColor).length <= 0) return undefined
      let data = this.cartData.boxColor
      let color = {
        id: data.no,
        name: data.name,
        type: data.type,
        no: data.dispNo,
        img: this.getImage('color/' + data.img),
        imgB: this.getImage('color/' + this.bigImage(data.img))
      }
      return color
    },
    colorCounter: function () {
      if (!this.cartData || !this.cartData.centerColor || Object.keys(this.cartData.centerColor).length <= 0) return undefined
      let data = this.cartData.centerColor
      let color = {
        id: data.no,
        name: data.name,
        type: data.type,
        no: data.dispNo,
        img: this.getImage('color/' + data.img),
        imgB: this.getImage('color/' + this.bigImage(data.img))
      }
      return color
    },
    corpData: function () {
      if (!this.cartData.corpData) return undefined
      let corpData = {
        corpName: this.cartData.corpData.corpName,
        postcd: this.cartData.corpData.postcd,
        address: ((this.cartData.corpData.state ? this.cartData.corpData.state : '') +
          (this.cartData.corpData.city ? this.cartData.corpData.city : '') +
          (this.cartData.corpData.street ? this.cartData.corpData.street : '')),
        tel: this.cartData.corpData.tel,
        fax: this.cartData.corpData.fax
      }
      return corpData
    },
    isDoor: function () {
      if (!this.cartData.doorColor || Object.keys(this.cartData.doorColor).length <= 0) return false
      return true
    },
    isCabine: function () {
      if (!this.cartData.boxColor || Object.keys(this.cartData.boxColor).length <= 0) return false
      return true
    },
    isCounter: function () {
      if (!this.cartData.centerColor || Object.keys(this.cartData.centerColor).length <= 0) return false
      return true
    },
    isConstruct: function () {
      return FormUtil.getOnOff(this.cartData.opExFlag)
    },
    isCarryIn: function () {
      if (this.cartData.opCarryFlag === undefined || this.cartData.opCarryFlag === null) return undefined
      return FormUtil.getOnOff(this.cartData.opCarryFlag)
    },
    optShelfTitle: function () {
      if (this.cartData.infoCategoryType === 5) return 'ご注文数'
      return '追加可動棚'
    },
    optShelfUnitTitle: function () {
      if (this.cartData.infoCategoryType === 5) return '枚'
      return '枚/列'
    },
    labelFiller: function () {
      if (this.cartData.infoCategoryType === 4) return '壁埋め込み'
      return 'フィラー'
    },
    labelLeftFiller: function () {
      if (this.cartData.infoCategoryType === 4) return '左壁埋め込み'
      return '左フィラー'
    },
    labelRightFiller: function () {
      if (this.cartData.infoCategoryType === 4) return '右壁埋め込み'
      return '右フィラー'
    },
    labelCenterFiller: function () {
      if (this.cartData.infoCategoryType === 4) return '奥壁埋め込み'
      return '上部フィラー'
    },
    doorColor: function () {
      if (!this.cartData.doorColor) return
      let bigName = FormUtil.bigImage(this.cartData.doorColor.img)
      let color = {
        id: this.cartData.doorColor.no,
        name: this.cartData.doorColor.name,
        type: this.cartData.doorColor.type,
        no: this.cartData.doorColor.dispNo,
        img: this.getImage('color/' + this.cartData.doorColor.img),
        imgB: this.getImage('color/' + bigName)
      }
      return color
    },
    boxColor: function () {
      if (!this.cartData.boxColor) return
      let bigName = FormUtil.bigImage(this.cartData.boxColor.img)
      let color = {
        id: this.cartData.boxColor.no,
        name: this.cartData.boxColor.name,
        type: this.cartData.boxColor.type,
        no: this.cartData.boxColor.dispNo,
        img: this.getImage('color/' + this.cartData.boxColor.img),
        imgB: this.getImage('color/' + bigName)
      }
      return color
    },
    centerColor: function () {
      if (!this.cartData.centerColor) return
      let bigName = FormUtil.bigImage(this.cartData.centerColor.img)
      let color = {
        id: this.cartData.centerColor.no,
        name: this.cartData.centerColor.name,
        type: this.cartData.centerColor.type,
        no: this.cartData.centerColor.dispNo,
        img: this.getImage('color/' + this.cartData.centerColor.img),
        imgB: this.getImage('color/' + bigName)
      }
      return color
    },
    isMiuraCompany: function () {
      if (this.cartData.corpData.corpId === 1001) {
        return true
      }
      return false
    },
    isExistStyle: function () {
      if (this.cartData.colorStyle && Object.keys(this.cartData.colorStyle).length > 0) {
        return true
      }
      return false
    }
  },
  methods: {
    onAfterCart: function (cartData) {
      this.$emit('afterCart', cartData.code)
    },
    onReverseCart: function (cartData) {
      this.$emit('reverseCart', cartData.code)
    },
    onEstimate: function (cartData) {
      let estimateData = {
        fileName: this.cartData.infoProductName,
        titleDoor: this.titleNoData.doorColor + '.扉カラー',
        colorDoor: this.doorColor,
        titleCabine: this.titleNoData.boxColor + '.キャビネット/棚/脚カラー',
        colorCabine: this.boxColor,
        titleCounter: this.titleNoData.centerColor + '.カウンターカラー',
        colorCounter: this.centerColor,
        priceData: this.priceData,
        spaceJoincd: this.cartData.infoSpaceJoincd,
        dcProductCount: this.cartData.infoProductCount,
        isDrawing: this.cartData.infoCategoryType !== 5,
        corpData: this.corpData,
        isProductData: this.isBeforeData
      }
      this.$emit('onShowEstimateModal', estimateData)
    },
    onCG: function (cartData) {
      this.$emit('showCameraModal', cartData)
    },
    onDelete: function (cartData) {
      this.$emit('deleteCartItem', cartData.code)
    },
    onUpdate: function (cartData) {
      this.$emit('updateProductCnt', cartData.code, cartData.infoProductCount)
    },
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    },
    bigImage: function (imgName) {
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return file + '_B' + exp
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      str = FormUtil.deleteTopZero(str)
      return str
    },
    setTitleNo: function () {
      let count = 1
      this.$set(this.titleNoData, 'filler', count++)
      this.$set(this.titleNoData, 'size', count++)
      if (this.cartData.doorColor && Object.keys(this.cartData.doorColor).length > 0) {
        this.$set(this.titleNoData, 'doorColor', count++)
      }
      if (this.cartData.boxColor && Object.keys(this.cartData.boxColor).length > 0) {
        this.$set(this.titleNoData, 'boxColor', count++)
      }
      if (this.cartData.centerColor && Object.keys(this.cartData.centerColor).length > 0) {
        this.$set(this.titleNoData, 'centerColor', count++)
      }
      this.$set(this.titleNoData, 'construct', count++)
      this.$set(this.titleNoData, 'price', count++)
    },
    profitPrice: function (price) {
      if (!price || !this.cartData) return
      return (Math.ceil(price / this.profitProb))
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  },
  mounted: function () {
  },
  created: function () {
    this.setTitleNo()
  }
}
</script>
<style src="../../css/dctop2.scss" lang="scss" scoped></style>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/common/CartItem.vue